"use client";
import Image, { StaticImageData } from "next/image";
import { Button } from "@/components/ui/button";
import * as images from "@/components/images/Images_second";
import Link from "next/link";
import { Typography } from "@/components/ui/typography";
import { TranslationDeliverablesCardLink } from "@/components/screen/global-components/translation-deliverables";
import { ROUTES } from "@/constants";

type CardItem = {
  title: string;
  img: string | StaticImageData;
  href: string;
};

export default function LanguageDocumentCard() {
  const cards: CardItem[] = [
    {
      title: "Affidavits",
      img: images.language_documents_card1,
      href: "/documents/affidavits",
    },
    {
      title: "Bank statements",
      img: images.language_documents_card2,
      href: "/documents/bank-statements",
    },
    {
      title: "Birth Certificate",
      img: images.language_documents_card3,
      href: "/documents/birth-certificate",
    },
    {
      title: "Contract",
      img: images.language_documents_card4,
      href: "/documents/contract",
    },
    {
      title: "Diploma",
      img: images.language_documents_card5,
      href: "/documents/diploma",
    },
    {
      title: "Financial Statement",
      img: images.language_documents_card6,
      href: "/documents/financial-statement",
    },
    {
      title: "Marriage Certificate",
      img: images.language_documents_card7,
      href: "/documents/marriage-certificate",
    },
    {
      title: "Passport",
      img: images.language_documents_card8,
      href: "/documents/passport",
    },
    {
      title: "Transcript",
      img: images.language_documents_card9,
      href: "/documents/transcript",
    },
  ];

  return (
    <section className="section bg-white lg:bg-background-secondary">
      <div className="container mx-auto py-12 lg:py-20">
        <div className="flex flex-col md:justify-center md:text-center gap-4 md:gap-2 md:w-full md:max-w-[746px] md:mx-auto">
          <Typography variant="heading4">
            <h2>What documents do we translate?</h2>
          </Typography>
          <div className="flex justify-center text-gray-600">
            <Typography variant="subHeadingSm" asChild>
              <p>
                We offer standard and certified Spanish translations for a range
                of documents and digital formats.
              </p>
            </Typography>
          </div>
        </div>
        <div className="mt-6 lg:mt-12">
          <div className="flex flex-wrap justify-center -m-2">
            {cards.map(({ href, img, title }, idx) => {
              return (
                <TranslationDeliverablesCardLink
                  key={idx}
                  href={href}
                  imageUrl={img}
                  imageAlt={title}
                  className="p-2 w-[50%] sm:w-[33.33%] md:w-[25%] lg:w-[20%] flex [&>a]:!pb-5"
                >
                  {title}
                </TranslationDeliverablesCardLink>
              );
            })}
          </div>
        </div>
        <div className="mt-6 lg:mt-12 text-center flex items-center justify-center">
          <Button
            asChild
            variant="primary-outline"
            className="py-3 px-6 h-[48px] w-full sm:w-auto"
          >
            <Link href={ROUTES.documentsAndDeliverables} className="!text-base">
              Explore documents
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
